import { AtsStaticTooltipParentRefEnum, isObjectWithProperty, safeJsonParse } from '@alliance/shared/utils'
import { LocalStorage } from '@alliance/shared/storage'
import { RxStateService } from '@alliance/shared/models'
import { Injectable } from '@angular/core'
import { PREVENT_SHOW_STATIC_TOOLTIP_STORAGE_KEY } from '../constants/constants'

@Injectable({
  providedIn: 'root'
})
export class StaticTooltipViewHelperService extends RxStateService<{ activeTooltipParentRef: AtsStaticTooltipParentRefEnum | null }> {
  public constructor(private localStorage: LocalStorage) {
    super()
    this.initState({
      activeTooltipParentRef: null
    })
  }

  public setActiveParentRef(activeTooltipParentRef: AtsStaticTooltipParentRefEnum | null): void {
    const { activeTooltipParentRef: currentRef } = this.get() ?? {}

    if (currentRef) {
      return
    }

    const currentPreventValues = this.currentPreventValues
    if (currentPreventValues) {
      const isKeyPresentInStorage = activeTooltipParentRef ? isObjectWithProperty<Record<AtsStaticTooltipParentRefEnum, boolean>>(currentPreventValues, activeTooltipParentRef) : false
      this.set({ activeTooltipParentRef: isKeyPresentInStorage ? null : activeTooltipParentRef })

      return
    }

    this.set({ activeTooltipParentRef })
  }

  public clearActiveParentState(): void {
    this.set({ activeTooltipParentRef: null })
  }

  public preventShowingTooltipByParentKey(key: AtsStaticTooltipParentRefEnum): void {
    const preventShowTooltipKeys = safeJsonParse(this.localStorage.getItem(PREVENT_SHOW_STATIC_TOOLTIP_STORAGE_KEY), {} as Record<AtsStaticTooltipParentRefEnum, boolean>)
    const updatedValue = JSON.stringify({ ...preventShowTooltipKeys, [key]: true })
    this.localStorage.setItem(PREVENT_SHOW_STATIC_TOOLTIP_STORAGE_KEY, updatedValue)
  }

  public isPrevented(key: AtsStaticTooltipParentRefEnum): boolean {
    const currentPreventValues = this.currentPreventValues

    return !!currentPreventValues[key]
  }

  private get currentPreventValues(): Record<AtsStaticTooltipParentRefEnum, boolean> {
    return safeJsonParse(this.localStorage.getItem(PREVENT_SHOW_STATIC_TOOLTIP_STORAGE_KEY), {} as Record<AtsStaticTooltipParentRefEnum, boolean>)
  }
}
